import React from 'react';
import { Link } from 'react-router-dom';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory , { PaginationProvider, PaginationTotalStandalone,SizePerPageDropdownStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';

import './DatasetClasses.css';

const DatasetClasses = props => {

    const classLinkFormatter = (cell, row) =>{  
        return (
          <Link to={`/classes/${row.id}`}> { cell } </Link>
         
        );
      } 

    const columns = [{
        dataField: 'label',
        text: 'Label',
        headerAlign: 'center',
        filter: textFilter(),
        formatter: classLinkFormatter,
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '20%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'uri',
        text: 'URI',
        headerAlign: 'center',
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '40%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'ontology',
        text: 'Ontology',
        headerAlign: 'center',
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '20%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'entities',
        text: 'Entities',
        align: 'right',
        headerAlign: 'center',
        sort: true,
        style: {'wordWrrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '10%', 'wordWrap': 'break-word'  };
          }
      }, {
        dataField: 'recommendations',
        text: 'Recommendations',
        align: 'right',
        headerAlign: 'center',
        sort: true,
        style: {'wordWrap': 'break-word' },
        headerStyle: (colum, colIndex) => {
            return { width: '10%', 'wordWrap': 'break-word' };
          }
      }
    ];

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
          &nbsp;Showing { from } to { to } of { size } classes
        </span>
      );

    const options = {
        custom: true,
        paginationTotalRenderer: customTotal,
        totalSize: props.cs.length
      };

     return (
         <div className="datasetClassesList">
          <h3>Classes</h3>

          <PaginationProvider pagination={ paginationFactory(options) }>
        {({paginationProps,paginationTableProps}) => (
        <div>
             <SizePerPageDropdownStandalone { ...paginationProps } />
             <PaginationTotalStandalone { ...paginationProps } />
            <PaginationListStandalone { ...paginationProps }/>
        
            <BootstrapTable
          keyField="id"
          data={ props.cs }
          columns={ columns }
          striped hover  filter={ filterFactory() }
          { ...paginationTableProps }
        />  
        {props.cs.length>10 && <SizePerPageDropdownStandalone { ...paginationProps } />}
        {props.cs.length>10 &&      <PaginationTotalStandalone { ...paginationProps } />}
         {props.cs.length>10 &&     <PaginationListStandalone { ...paginationProps }/>}
        
        </div>
        )
        }
        </PaginationProvider>


            </div>
     );
};

export default DatasetClasses;